import {
  TIPOS_PERSONA_DOCUMENTO,
  LINEAS_CREDITO_DOCUMENTO,
} from "../../../Arrays/DocumentosCreditoArray";

// Validación del formulario de documentos (alta / edición).
// Actualizado: 2026-09-17 — IA (Claude): se agrega documento_cobranza.
// Actualizado: 2026-09-16 — IA (Claude). Se reemplazan las expresiones genéricas
// (no aceptaban acentos ni signos comunes) y se devuelve una lista de mensajes claros.
// El backend debe repetir estas validaciones (Data Annotations en el modelo).
export const DOCUMENTO_MAX_LENGTH = 100;
export const DIAS_VIGENCIA_MAX = 3650;

const REGEX_DOCUMENTO = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9 .,()/\-]+$/;

const esValorDeCatalogo = (catalogo, valor) => catalogo.some((item) => item.value === valor);

export const ValDocumentos = (form) => {
  const errores = [];
  const documento = String(form.documento ?? "").trim().replace(/\s+/g, " ");
  const diasTexto = String(form.dias_vigencia ?? "").trim();
  const dias = Number(diasTexto);

  if (!documento) {
    errores.push("Captura el nombre del documento.");
  } else if (documento.length > DOCUMENTO_MAX_LENGTH) {
    errores.push(`El nombre del documento no puede exceder ${DOCUMENTO_MAX_LENGTH} caracteres.`);
  } else if (!REGEX_DOCUMENTO.test(documento)) {
    errores.push("El nombre del documento solo puede contener letras, números, espacios y los signos . , - / ( ).");
  }

  if (!esValorDeCatalogo(TIPOS_PERSONA_DOCUMENTO, form.tipopersona)) {
    errores.push("Selecciona el tipo de persona.");
  }

  if (!esValorDeCatalogo(LINEAS_CREDITO_DOCUMENTO, form.linea_credito)) {
    errores.push("Selecciona la línea de crédito.");
  }

  if (diasTexto === "" || !Number.isInteger(dias) || dias < 0 || dias > DIAS_VIGENCIA_MAX) {
    errores.push(`Los días de vigencia deben ser un número entero entre 0 y ${DIAS_VIGENCIA_MAX}.`);
  }

  if (errores.length > 0) return { isValid: false, errores };

  return {
    isValid: true,
    post: {
      iddocumento: Number(form.iddocumento) > 0 ? Number(form.iddocumento) : -999,
      documento: documento.toUpperCase(),
      tipopersona: form.tipopersona,
      linea_credito: form.linea_credito,
      Opcional: Boolean(form.opcional),
      Documentacion: Boolean(form.documentacion),
      fase2: Boolean(form.fase2),
      documento_cobranza: Boolean(form.documento_cobranza),
      dias_vigencia: dias,
      jdf: Number(form.jdf),
      estatus: 1,
    },
  };
};
